if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.querySelectorAll('.js-amenities-icons li').forEach(li => {
        li.dataset.content = li.textContent.replace(/\s*\(.*?\)\s*/g, '').replace(/\s+/g, '-').trim().toLowerCase();
    });


    $('.sym-slides').slick();
    
	$('.trio-slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5500,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 769,
				settings: { slidesToShow: 2 }
			},
			{
				breakpoint: 480,
				settings: { 
					slidesToShow: 1
				}
			}
		]
	});

    $('.sym-slides-rooms').slick({
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $(".sym-slides-num").slick({
        customPaging: function(slider, i) {
            return '<a>'+(i+1)+'</a>';
        }
    });

    $('.prevSlick').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num').slick('slickPrev');
    });
    $('.nextSlick').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num').slick('slickNext');
    });

    $(".sym-slides-num-br").slick({
        customPaging: function(slider, i) {
            return '<a>'+(i+1)+'</a>';
        }
    });
    $(".sym-slides-num-bl").slick({
        customPaging: function(slider, i) {
            return '<a>'+(i+1)+'</a>';
        }
    });

    $('.prevSlick-br').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num-br').slick('slickPrev');
    });
    $('.nextSlick-br').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num-br').slick('slickNext');
    });
    $('.prevSlick-blo').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num-bl').slick('slickPrev');
    });
    $('.nextSlick-blo').on('click', function (e) {
        e.preventDefault();
        $('.sym-slides-num-bl').slick('slickNext');
    });

    //fancybox
    $('.fancybox-copy').fancybox({
        wrapCSS : 'fullFancyCopy'
    });
    $('.fancybox').fancybox({
        padding: 0
    });
    $('.fancybox-vid').fancybox({
        'type':"iframe"
    });
    $('.landing-page-tabs li').click(function(){
        $('.landing-page-tabs li, .tab-content').removeClass('active');
        var activeTab = $(this).attr('data-rel');
        $(this).addClass('active');
        $("#" + activeTab).addClass('active');
    });

    // Toggle Links - use ID of target element to toggle 'open' class state
    $(".toggle-link").on('click', function(e){
        e.preventDefault();
        let $target = $("#" + e.currentTarget.getAttribute('data-target'));
        $target.toggleClass("open");
    });

    let disambleWelcomeEmailField = document.querySelector("form [name='disabled_welcome_email']")
    if(disambleWelcomeEmailField){
        disambleWelcomeEmailField.setAttribute('value', '1');
    }

}());